import {AxiosError} from 'axios';
import {useCustomMutation} from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import {POST_GENERATE_REPORT, POST_NON_NATIONAL_GENERATE_REPORT} from '../../constants/apiUrls';
import {SubjectExamSchema} from '../../api/candidate/registration-report/model';
import {GenericErrorResponse, KeyValueResponse} from '../typings';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PostGenerateReportRequest {
  subjectExamLevel: SubjectExamSchema[] | []
  candidateExamLevel: KeyValueResponse[] | [],
  examSeries: KeyValueResponse[],
  startDate: string,
  endDate: string
}

export interface NonNationalReportRequest {
  examLevel: KeyValueResponse[] | [],
  academicLevel: KeyValueResponse[] | []
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: any) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostGenerateReport = ({onSuccess, onError}: Input = {}) => {
  const postGenerateReport = async (reqBody: PostGenerateReportRequest) => {
    const res = await axiosClient.post(POST_GENERATE_REPORT, reqBody);

    return res.data
  };

  return useCustomMutation(postGenerateReport, {
    onSuccess,
    onError,
  });
};

export const usePostNonNationalReport = ({onSuccess, onError}: Input = {}) => {
  const postNonNationalGenerateReport = async (reqBody: NonNationalReportRequest) => {
    const res = await axiosClient.post(POST_NON_NATIONAL_GENERATE_REPORT, reqBody);

    return res.data
  };

  return useCustomMutation(postNonNationalGenerateReport, {
    onSuccess,
    onError,
  });
};
